import { useEffect } from "react";
import "../styles/OurServices.css";
import SearchIcon from "../search-icon.svg";
import Test from "../test.svg";
import Forume from "../forum.svg";
export default function OurServices({setActive, pagesOut}) {
  const services = [
    {
      title: "رؤية المنصة",
      description:
        `رؤية المنصة هي أن تكون مكتبة شاملة لكل المراحل التعليمية من الصفوف الابتدائية وحتي الجامعة, كما انه توجد كورسات منفردة في عدة مجالات مثل البرمجة، الذكاء الاصطناعي، إدارة الأعمال، واللغات.
        جذب المعلمين والطلاب عن طريق الميزات المتاحة والسهولة في الاستخدام\nالحفاظ على التراث العربي ودعم لغتنا العربية`,
        icon: SearchIcon
    },
    {
      title: "الاختبارات التفاعلية",
      description:
        "اختبر نفسك من خلال اختبارات تفاعلية تعزز فهمك وتحدد مستواك بدقة.",
        icon: Test
    },
    {
      title: "منتديات النقاش",
      description:
        "شارك الأسئلة والأفكار مع المجتمع، واحصل على دعم من الزملاء والمحاضرين.",
        icon: Forume
    },
    
  ];

  useEffect(()=>{
    setActive("خدماتنا");
  },[])

  return (
    <div className="our-service-container">
      <header className="">
        <h1 className={`${pagesOut.servicesOut? "home-h-out": "home-h-in"}`}>خدماتنا</h1>
        <p className={`${pagesOut.servicesOut? "home-p-out": "home-p-in"}`}>
          نحن هنا لنقدم لك تجربة تعليمية متكاملة تساعدك على التعلم، التفاعل، والتطور,سهولة التواصل مع الطلاب
        </p>
        <p className={`${pagesOut.servicesOut? "home-p-out": "home-p-in"}`}>تجربة تعليمية جديدة سهلة وسلسة وفريدة من نوعها</p>
      </header>
      <section className="services-section">
        {services.map((service, index) => (
          <div style={{ display: "flex", justifyContent: "center", width:"90%" }}
            className={pagesOut.servicesOut?"home-h-out":"home-p-in"}
          >
          <div
            key={index}
            className="service-card"
          > 
            <h2 className={`${pagesOut.servicesOut? "home-h-out": "home-h-in"}`}>
              {service.title}
            </h2>
            <div style={{display:"flex"}}>
              <img src={service.icon} alt="no"
                style={{position:"relative" , top:"-30px", right:"-15px", height:"10%", width:"10%"}}
              />
              <p className={`${pagesOut.servicesOut? "home-p-out": "home-p-in"}`}
              style={{textAlign:"right", width:"80%"}}
              >{service.description}</p>
            </div>
          </div>
          </div>
        ))}
      </section>
    </div>
  );
}
